// Author: Luis Booth - January 2019
// Most complex component ever.

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { VacationContext } from 'js/components/step1/VacationContext';

class GuestCounter extends Component {

  render() {

    return (
      <VacationContext.Consumer>
        {(context) => {
          const { name, count } = this.props;

          return (
            <div className="counter-wrapper util-no-padding">
              <button className={`${count > 0 ? '' : 'disable-btn'}`} onClick={context.setGuestCount(-1, name)}>
                <i className="icon-minus-circle" />
              </button>

              <div className="number-count d-inline-block util-txt-center">{ count }</div>

              <button onClick={context.setGuestCount(1, name)}>
                <i className="icon-plus-circle" />
              </button>
            </div>
          );
        }}
      </VacationContext.Consumer>
    );
  }
}

export default GuestCounter;

// returnCount takes in a function, and runs it with the current count as the first argument.
// limitCounter will prevent the counter to keep adding.
GuestCounter.defaultProps = {
  count: 0,
  minCount: 0,
  returnCount: () => {},
  limitCounter: false,
  getCount: () => {},
};

GuestCounter.propTypes = {
  initialCount: PropTypes.number,
  minCount: PropTypes.number,
  maxCount: PropTypes.number,
  returnCount: PropTypes.func,
  limitCounter: PropTypes.bool,
  getCount: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/step1/GuestCounter.js